import { getToken, logout } from "./auth"

const API_BASE_URL = process.env.REACT_APP_API_URL

/**
 * Get authorization headers with token
 * @returns {Object} Headers object with Authorization
 */
const getAuthHeaders = () => {
  const token = getToken()
  if (!token) {
    console.log("[v0] Warning: No token available for API call")
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }
}

const handleResponse = async (response) => {
  const data = await response.json()

  // Check for expired/invalid token
  if (!response.ok || data.success === false) {
    if (
      data.message?.toLowerCase().includes("invalid") ||
      data.message?.toLowerCase().includes("expired") ||
      data.message?.toLowerCase().includes("token") ||
      response.status === 401 ||
      response.status === 403 )
    // ) {
    //   console.log("[v0] Authentication error detected. Logging out and redirecting to login.")
    //   logout()
    //   // Use replace to prevent back button issues
    //   window.location.href = "/admin/login"
    //   // Still throw error for component-level handling
    //   throw new Error("Session expired. Please login again.")
    // }
    throw new Error(data.message || "API request failed")
  }

  return data
}

/**
 * Get all contact messages for admin
 * @param {string} status - Optional filter by status (New, Closed)
 * @returns {Promise<Object>} - Response with contact messages
 */
export const getContactMessages = async (status = null) => {
  const url = new URL(`${API_BASE_URL}/contact-messages/admin/messages`)
  if (status) {
    url.searchParams.append('status', status)
  }
  
  const response = await fetch(url.toString(), {
    method: "GET",
    headers: getAuthHeaders(),
  })

  return handleResponse(response)
}

/**
 * Reply to a contact message
 * @param {string} messageId - The ID of the message to reply to
 * @param {string} replyText - The text content of the reply
 * @returns {Promise<Object>} - Response with success status
 */
export const replyToMessage = async (messageId, replyText) => {
  const response = await fetch(`${API_BASE_URL}/contact-messages/admin/messages/${messageId}/reply`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ reply: replyText }),
  })

  return handleResponse(response)
}
